import React from 'react';
import {useDispatch} from 'react-redux'
import {Modal, Button} from 'semantic-ui-react';

import {isPresent, useAccessibleModal} from "../../helpers";

const ModalDialog = ({title, onClose, actions, children: content}) => {
    const defActionComps = [
        <Button className="cuddle" onClick={onClose}>OK</Button>,
    ];
    let actionComps = defActionComps;
    const dispatch = useDispatch();
    const a11y = useAccessibleModal(isPresent(title) ? title : "Hinweis");
    if (actions && actions.size > 0) {
        actionComps = actions.map(a => (
            <Button className="cuddle" onClick={() => {
                const aDesc = a.get(1);
                onClose && onClose();
                aDesc && (aDesc !== -1) && dispatch(aDesc.toJS());
            }}
            >
                {a.get(0)}
            </Button>
        ));
    }
    return (
        <Modal defaultOpen onClose={onClose} size='tiny' {...a11y}
            aria-describedby={`${a11y.id}-description`}
        >
            {isPresent(title)?<Modal.Header>{title}</Modal.Header>:null}
            <Modal.Content>
                <Modal.Description id={`${a11y.id}-description`}>
                    {content}
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                {actionComps}
            </Modal.Actions>
        </Modal>
    );
};

export default ModalDialog;
